module.exports = __webpack_public_path__ + "static/morris-moor-7e09cd85e819b3b08f3763ee5b501df1.jpg";